import { ReviewRepository } from "../../repositories/ReviewRepository";

/**
 * Approve Review Use Case
 * Approves a review request
 */
export class ApproveReviewUseCase {
  constructor(private repository: ReviewRepository) {}

  async execute(id: number, comments?: string): Promise<void> {
    if (!id || id <= 0) {
      throw new Error("Invalid review ID");
    }

    return await this.repository.approveReview(id, comments);
  }
}
